var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulletCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "9px",
    viewBox: "0 0 12 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CTAs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clyde-Modal-Opt3-Default-Hover",
    transform: "translate(-518.000000, -580.000000)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(518.000000, 533.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(0.423039, 45.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    transform: "translate(5.207262, 4.630301) rotate(-315.000000) translate(-5.207262, -4.630301) ",
    points: "7.41452346 0.289328465 7.41452346 8.96889124 3 8.97127255"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletCheckmark);
export default __webpack_public_path__ + "static/media/bullet-checkmark.c0c88d0f7c64555eca0674295a2414ed.svg";
export { ForwardRef as ReactComponent };